import { Getter } from "vuex";
import { IState } from "./state";

const title: Getter<IState, IState> = (state) => state.title;
const titleUri: Getter<IState, IState> = (state) => state.titleUri;
const hideTopLevel: Getter<IState, IState> = (state) => state.hideTopLevel;
const hasThirdLevel: Getter<IState, IState> = (state) => state.hasThirdLevel;
const chaptersArray: Getter<IState, IState> = (state) => state.chaptersArray;

export default {
  title,
  titleUri,
  hideTopLevel,
  hasThirdLevel,
  chaptersArray,
};
